import { Provider } from '@angular/core';
import { BuildingModelAssetsService } from '../services/building-model-assets.service';
import { HttpBuildingModelAssetsService } from '../services/http-building-model-assets.service';

/** Registers `BuildingModelAssetsService` (`HttpBuildingModelAssetsService`). */
export function provideBuildingModelAssets(): Provider[] {
  return [
    {
      provide: BuildingModelAssetsService,
      useClass: HttpBuildingModelAssetsService,
    },
  ];
}
